import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-generic-zero-ui',
  templateUrl: './generic-zero-ui.component.html',
  styleUrls: ['./generic-zero-ui.component.scss']
})
export class GenericZeroUiComponent implements OnInit {

  constructor(
    private viewContainerRef:ViewContainerRef
  ) { }

  ngOnInit() {
    var consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if(environment && !environment.production){
      console.group('%cGeneric Zero UI : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log("%c<app-generic-zero-ui></app-generic-zero-ui>, has been used. ", consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log("%cExample , <app-generic-zero-ui [list]='AnimalListObject' title='Animal Search' message='No Animals found in the list' icon='user'></app-generic-zero-ui>", consoleStyle)
      console.groupEnd();
    }
  }

  /**
   * ComponentSpecific Inputs, Outputs and Functions
   *
   */
  @Output() componentOutput = new EventEmitter<any>();
  @Input() title: string = "No Data";
  @Input() message: string = "No data found in the List";
  @Input() icon: string = "question-circle";
  @Input() size: string = "big"; /* big/small */
  @Input() list: Array<any>;
  EmitComponentOutput(data) {
    this.componentOutput.emit(data)
  }
  getParentComponent(): Component {
    try { return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component } catch { };
  }
  getParentComponentName(): Component {
    try { return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name } catch { };
  }

  inputValidation(){

  }

}
